import React from 'react';
import {Comment, Avatar, PageHeader} from 'antd';

const Authors = () => {
    return (
        <>
            <PageHeader
                className="site-page-header"
                title="Авторы"
            />
        <Comment
            author={<a>Алексей - team-lead</a>}
            avatar={
                <Avatar
                    src="https://avatars3.githubusercontent.com/u/36966014?s=400&v=4"
                    alt="Алексей"
                />
            }
            content={
                <a href='https://github.com/Darzamat12'>https://github.com/Darzamat12</a>
            }
        />
            <Comment
                author={<a>Тимофей</a>}
                avatar={
                    <Avatar
                        src="https://avatars3.githubusercontent.com/u/60549991?s=400&u=ffc9f49857ec6dc14204e07699ed032fefb3b842&v=4"
                        alt="Тимофей"
                    />
                }
                content={
                    <a href='https://github.com/keksik77'>https://github.com/keksik77</a>
                }
            />
            <Comment
                author={<a>Анастасия</a>}
                avatar={
                    <Avatar
                        src="https://avatars3.githubusercontent.com/u/47385821?s=400&u=5cd06097a0ba0836897efb1b08449084bd9115e9&v=4"
                        alt="Анастасия"
                    />
                }
                content={
                    <a href='https://github.com/nastja2000'>https://github.com/nastja2000</a>
                }
            />
            <Comment
                author={<a>Павел</a>}
                avatar={
                    <Avatar
                        src="https://avatars0.githubusercontent.com/u/14905507?s=400&u=3271a3be8f7559d038de42a7f3dc2f547658d0bd&v=4"
                        alt="Павел"
                    />
                }
                content={
                    <a href='https://github.com/Ftorik'>https://github.com/Ftorik</a>
                }
            />
            <Comment
                author={<a>Алексей</a>}
                avatar={
                    <Avatar
                        src="https://avatars0.githubusercontent.com/u/60549587?s=400&u=c333995d3d774eabf6b35da0f4f0b7c506dca7a1&v=4"
                        alt="Алексей"
                    />
                }
                content={
                    <a href='https://github.com/moygospadin'>https://github.com/moygospadin</a>
                }
            />
            <Comment
                author={<a>Татьяна</a>}
                avatar={
                    <Avatar
                        src="https://avatars1.githubusercontent.com/u/47864802?s=400&u=20d14335d6d4cb1b8e9750ad9a6cc96f11ddd7a4&v=4"
                        alt="Татьяна"
                    />
                }
                content={
                    <a href='https://github.com/tv-dem'>https://github.com/tv-dem</a>
                }
            />
            <Comment
                author={<a>Юлия</a>}
                avatar={
                    <Avatar
                        src="https://avatars2.githubusercontent.com/u/59354191?s=460&u=11ed28e5863dcf8196d0d0e7616b2dfa6ebc06f1&v=4"
                        alt="Юлия"
                    />
                }
                content={
                    <a href='https://github.com/secondnumber'>https://github.com/secondnumber</a>
                }
            />
        </>
    );
};

export default Authors;